
import { Header } from "@/components/layout/Header";

export const TestEmpty = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="flex flex-col items-center justify-center gap-4">
          <p className="text-lg text-gray-700">No questions available for this test</p>
          <p className="text-sm text-gray-500">Test ID may be invalid or no questions have been added yet.</p>
        </div>
      </main>
    </div>
  );
};
